import React from "react";
import { getIconColor } from "../../helper/helpers";

const primarySvgColor = "#1e9eff";
export const IntradoLogo = () => (
  <svg id="Layer_1" data-name="Layer 1" viewBox="0 0 229.06 76.59">
    <path
      id="Path_10121"
      data-name="Path 10121"
      style={{ fill: "#fff" }}
      d="M10.34,49.73H0V0H10.35Z"
    />
    <path
      id="Path_10122"
      data-name="Path 10122"
      style={{ fill: "#fff" }}
      d="M51.46,49.73H41.11V28.16a6.27,6.27,0,0,0-1.91-4.6,6.54,6.54,0,0,0-11.14,4.56V49.73H17.73V12.3H28.06v2a11.28,11.28,0,0,1,8.05-3,14.26,14.26,0,0,1,11,4.9A17.24,17.24,0,0,1,51.53,28.2Z"
    />
    <path
      id="Path_10123"
      data-name="Path 10123"
      style={{ fill: "#fff" }}
      d="M75.41,22.65H70.49V49.73H60.15V22.65H55.23V12.3h4.92V0H70.49V12.3h4.92Z"
    />
    <path
      id="Path_10124"
      data-name="Path 10124"
      style={{ fill: "#fff" }}
      d="M98.91,21.67H97.17a6.45,6.45,0,0,0-6.49,6.41V49.73H80.34V12.3H90.68v2a11.57,11.57,0,0,1,8.23-3Z"
    />
    <path
      id="Path_10125"
      data-name="Path 10125"
      style={{ fill: "#fff" }}
      d="M140,49.73H129.69V47.18q-3.1,3.54-10.33,3.54A17.53,17.53,0,0,1,105.94,45a19.74,19.74,0,0,1-5.37-14,19.52,19.52,0,0,1,5.37-13.95,17.6,17.6,0,0,1,13.3-5.75q7.13,0,10.33,3.6V12.24h10.35ZM129.69,31A9.3,9.3,0,1,0,127,37.65,9.05,9.05,0,0,0,129.69,31Z"
    />
    <path
      id="Path_10126"
      data-name="Path 10126"
      style={{ fill: "#fff" }}
      d="M184.53,49.73H174.18V47.18q-3.09,3.54-10.34,3.54A17.5,17.5,0,0,1,150.42,45a19.78,19.78,0,0,1-5.37-14,19.54,19.54,0,0,1,5.37-13.95,17.63,17.63,0,0,1,13.3-5.74q7.16,0,10.34,3.6V0h10.35ZM174.18,31a9.32,9.32,0,1,0-2.68,6.63A9,9,0,0,0,174.18,31Z"
    />
    <path
      id="Path_10127"
      data-name="Path 10127"
      style={{ fill: "#fff" }}
      d="M229.06,31a19.71,19.71,0,1,1-12.17-18.24A19.71,19.71,0,0,1,229.06,31Zm-10.34,0A9.34,9.34,0,1,0,216,37.65,9,9,0,0,0,218.68,31Z"
    />
    <path
      id="Path_10132"
      data-name="Path 10132"
      style={{ fill: "#fff" }}
      d="M2.79,65.6h11V57.44h2.35V76.1H13.81V67.82h-11V76.1H.44V57.44H2.79Z"
    />
    <path
      id="Path_10133"
      data-name="Path 10133"
      style={{ fill: "#fff" }}
      d="M32.61,69.77a6.71,6.71,0,1,1-6.82-6.59h.11a6.5,6.5,0,0,1,6.7,6.28C32.61,69.56,32.61,69.67,32.61,69.77Zm-11.17,0a4.47,4.47,0,1,0,4.47-4.54,4.39,4.39,0,0,0-4.47,4.3Z"
    />
    <path
      id="Path_10134"
      data-name="Path 10134"
      style={{ fill: "#fff" }}
      d="M46.74,70.79a5.38,5.38,0,0,1-5.14,5.6c-.21,0-.42,0-.63,0-3,0-5.79-1.75-5.79-5.59V63.44h2.19v7.23a3.6,3.6,0,0,0,7.2.34V63.44h2.17Z"
    />
    <path
      id="Path_10135"
      data-name="Path 10135"
      style={{ fill: "#fff" }}
      d="M58.81,66.26a7.85,7.85,0,0,0-4-1.18c-1.73,0-2.86.74-2.86,1.88s.92,1.49,2.45,1.67l1.47.18c2.68.36,4.28,1.5,4.28,3.6,0,2.4-2.16,4-5.61,4a9,9,0,0,1-5.37-1.63l1-1.63a6.56,6.56,0,0,0,4.33,1.35c2.08,0,3.36-.69,3.36-1.94,0-.94-.82-1.53-2.55-1.74l-1.48-.16c-2.83-.34-4.21-1.63-4.21-3.54,0-2.43,2-3.89,5.1-3.89a9,9,0,0,1,5,1.33Z"
    />
    <path
      id="Path_10136"
      data-name="Path 10136"
      style={{ fill: "#fff" }}
      d="M73.88,69.73v.82h-10a4.12,4.12,0,0,0,4.3,3.92A5.86,5.86,0,0,0,72.07,73l1.16,1.5A7.16,7.16,0,0,1,68,76.37a6.6,6.6,0,1,1-.13-13.2C71.37,63.17,73.85,65.86,73.88,69.73Zm-10-1h7.74a3.8,3.8,0,0,0-3.77-3.68,3.94,3.94,0,0,0-4,3.68Z"
    />
    <path
      id="Path_10137"
      data-name="Path 10137"
      style={{ fill: "#fff" }}
      d="M93.18,61l-2,1.34a6.69,6.69,0,0,0-5.73-2.95,7.38,7.38,0,1,0,0,14.76h0a6.7,6.7,0,0,0,5.66-2.93l1.92,1.35a9,9,0,0,1-7.58,3.8,9.62,9.62,0,0,1-.74-19.23c.25,0,.49,0,.74,0A8.84,8.84,0,0,1,93.18,61Z"
    />
    <path
      id="Path_10139"
      data-name="Path 10139"
      style={{ fill: "#fff" }}
      d="M113.67,76.11h-2.18V56.91h2.18Z"
    />
    <path
      id="Path_10140"
      data-name="Path 10140"
      style={{ fill: "#fff" }}
      d="M119.52,76.11h-2.18V56.91h2.18Z"
    />
    <path
      id="Path_10141"
      data-name="Path 10141"
      style={{ fill: "#fff" }}
      d="M131.71,66.26a7.72,7.72,0,0,0-4-1.18c-1.73,0-2.85.74-2.85,1.88s.92,1.49,2.46,1.67l1.46.18c2.69.36,4.28,1.5,4.28,3.6,0,2.4-2.16,4-5.61,4a9,9,0,0,1-5.36-1.63l1-1.63a6.5,6.5,0,0,0,4.33,1.34c2.08,0,3.35-.68,3.35-1.93,0-.94-.83-1.53-2.54-1.74l-1.49-.16c-2.85-.34-4.22-1.63-4.22-3.55,0-2.42,2-3.89,5.09-3.89a9.2,9.2,0,0,1,5.06,1.34Z"
    />
    <path
      id="Path_10142"
      data-name="Path 10142"
      style={{ fill: "#fff" }}
      d="M144.38,68.65V76.1H142V57.44h7.1c4.22,0,6.59,2.11,6.59,5.6s-2.37,5.61-6.59,5.61Zm0-9v6.71h4.7c2.75,0,4.21-1.13,4.21-3.4s-1.46-3.38-4.21-3.38Z"
    />
    <path
      id="Path_10143"
      data-name="Path 10143"
      style={{ fill: "#fff" }}
      d="M166.6,63.59l-.54,2.15a4.67,4.67,0,0,0-2.17-.5c-1.92.06-3.26,1.47-3.26,3.81v7h-2.17V63.44h2.17v1.67a4.48,4.48,0,0,1,3.7-1.94,5.69,5.69,0,0,1,2.27.42Z"
    />
    <path
      id="Path_10144"
      data-name="Path 10144"
      style={{ fill: "#fff" }}
      d="M180.57,69.77a6.71,6.71,0,1,1-6.82-6.59h.11a6.52,6.52,0,0,1,6.71,6.31Zm-11.18,0a4.47,4.47,0,1,0,4.47-4.54,4.39,4.39,0,0,0-4.47,4.3Z"
    />
    <path
      style={{ fill: "#fff" }}
      d="M107.83,76.11l0-12.66h-2.19v1.7a5.6,5.6,0,0,0-4.46-2,6.6,6.6,0,0,0,0,13.2,5.6,5.6,0,0,0,4.46-2v1.69Zm-6.64-2a4.29,4.29,0,1,1,4.29-4.29A4.29,4.29,0,0,1,101.19,74.13Z"
    />
  </svg>
);

export const HelpLinkSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.75"
      height="13.75"
      viewBox="0 0 13.75 13.75"
    >
      <path
        // fill="#fafafa"
        d="M14.313 7.438A6.875 6.875 0 1 1 7.438.563a6.875 6.875 0 0 1 6.875 6.875zm-6.691-4.6A3.591 3.591 0 0 0 4.391 4.6a.333.333 0 0 0 .075.451l.962.729a.333.333 0 0 0 .462-.059c.5-.628.835-.992 1.589-.992.566 0 1.267.364 1.267.914 0 .415-.343.628-.9.942-.652.366-1.515.821-1.515 1.959v.111a.333.333 0 0 0 .333.333h1.55a.333.333 0 0 0 .333-.333V8.62c0-.789 2.306-.822 2.306-2.957a3.163 3.163 0 0 0-3.231-2.827zm-.184 6.873a1.275 1.275 0 1 0 1.275 1.275 1.277 1.277 0 0 0-1.275-1.275z"
        transform="translate(-.563 -.563)"
      />
    </svg>
  );
};

export const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.49"
    height="14.492"
    viewBox="0 0 14.49 14.492"
  >
    <path
      fill="#777"
      d="M14.293 12.53l-2.822-2.822a.679.679 0 0 0-.481-.2h-.461a5.884 5.884 0 1 0-1.019 1.021v.461a.679.679 0 0 0 .2.481l2.822 2.822a.676.676 0 0 0 .959 0l.8-.8a.682.682 0 0 0 0-.962zM5.887 9.51A3.623 3.623 0 1 1 9.51 5.887 3.621 3.621 0 0 1 5.887 9.51z"
    />
  </svg>
);
export const MenuIcon = () => {
  const style = {
    fill: "#777",
    stroke: "#777",
    strokeLinCap: "round",
    strokeLineJoin: "round",
    strokeWidth: "2px",
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="4.28"
      height="20.218"
      viewBox="0 0 4.28 20.218"
    >
      <g id="Icon_feather-more-vertical" transform="translate(1 1)">
        <path
          id="Path_4088"
          d="M18.779 17.639A1.14 1.14 0 1 1 17.64 16.5a1.14 1.14 0 0 1 1.139 1.139z"
          style={style}
          transform="translate(-16.499 -8.53)"
        />
        <path
          id="Path_4089"
          d="M18.779 7.139A1.14 1.14 0 1 1 17.64 6a1.14 1.14 0 0 1 1.139 1.139z"
          style={style}
          transform="translate(-16.499 -6)"
        />
        <path
          id="Path_4090"
          d="M18.779 28.139A1.14 1.14 0 1 1 17.64 27a1.14 1.14 0 0 1 1.139 1.139z"
          style={style}
          transform="translate(-16.499 -11.06)"
        />
      </g>
    </svg>
  );
};

export const CloseIcon = () => {
  const style = {
    fill: "none",
    stroke: "#777",
    strokeLineCap: "round",
    strokeWidth: "2px",
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11.77"
      height="11.819"
      viewBox="0 0 11.77 11.819"
    >
      <g id="Group_57" transform="translate(1.414 1.414)">
        <path
          id="Path_32"
          d="M5989.941 7529.029l-8.94 8.991"
          style={style}
          transform="translate(-5980.999 -7529.029)"
        />
        <path
          id="Path_33"
          d="M5981 7529.029l8.939 8.991"
          style={style}
          transform="translate(-5981 -7529.029)"
        />
      </g>
    </svg>
  );
};

export const ErrorIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41.332"
    height="41.332"
    viewBox="0 0 41.332 41.332"
  >
    <path
      fill="#777"
      d="M21.6 29.866h4.133V34H21.6zm0-16.533h4.133v12.4H21.6zM23.645 3a20.666 20.666 0 1 0 20.687 20.666A20.656 20.656 0 0 0 23.645 3zm.021 37.2A16.533 16.533 0 1 1 40.2 23.666 16.528 16.528 0 0 1 23.666 40.2z"
      opacity="0.3"
      transform="translate(-3 -3)"
    />
  </svg>
);

export const LogoutSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11.518"
    height="10.078"
    viewBox="0 0 11.518 10.078"
  >
    <path
      fill="#fff"
      d="M7.2 0v1.44H1.44v7.2H7.2v1.44H0V0zm1.44 2.879l2.879 2.16L8.638 7.2V5.759H2.879v-1.44h5.759z"
    />
  </svg>
);

export const SendIcon = () => {
  const color = getIconColor() || primarySvgColor;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.989"
      height="20.562"
      viewBox="0 0 23.989 20.562"
    >
      <path
        fill={color}
        d="M3.011 25.062l23.978-10.281L3.011 4.5 3 12.5l17.135 2.285L3 17.066z"
        transform="translate(-3 -4.5)"
      />
    </svg>
  );
};
export const CheckIcon = ({ success = false }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
    >
      <path
        fill={success ? "#00a87e" : "#bebfc0"}
        d="M13.563 7.063a6.5 6.5 0 1 1-6.5-6.5 6.5 6.5 0 0 1 6.5 6.5zM6.311 10.5l4.823-4.823a.419.419 0 0 0 0-.593L10.54 4.5a.419.419 0 0 0-.593 0L6.014 8.428 4.178 6.592a.419.419 0 0 0-.593 0l-.593.593a.419.419 0 0 0 0 .593L5.718 10.5a.419.419 0 0 0 .593 0z"
        transform="translate(-.563 -.563)"
      />
    </svg>
  );
};
export const FailedIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
  >
    <path
      fill="#b1203d"
      d="M9.5 3A6.5 6.5 0 1 0 16 9.5 6.5 6.5 0 0 0 9.5 3zm.65 9.75h-1.3v-1.3h1.3zm0-2.6h-1.3v-3.9h1.3z"
      transform="translate(-3 -3)"
    />
  </svg>
);
export const SMSIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
  >
    <path
      fill="#777"
      d="M14.7 3H4.3a1.3 1.3 0 0 0-1.294 1.3L3 16l2.6-2.6h9.1a1.3 1.3 0 0 0 1.3-1.3V4.3A1.3 1.3 0 0 0 14.7 3zM7.549 8.849H6.25v-1.3h1.3zm2.6 0h-1.3v-1.3h1.3zm2.6 0h-1.3v-1.3h1.3z"
      opacity="0.7"
      transform="translate(-3 -3)"
    />
  </svg>
);
export const EmailIconLarge = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="18"
    viewBox="0 0 24 18"
  >
    <path
      data-name="Icon zocial-email"
      d="M.072 20.474V5.662q0-.026.069-.489l7.846 7.457-7.822 8.358a2.4 2.4 0 0 1-.093-.514zM1.113 4.145a.91.91 0 0 1 .393-.077h21.13a1.192 1.192 0 0 1 .417.077l-7.869 7.483-1.041.926-2.06 1.877-2.06-1.877-1.041-.926zm.023 17.846 7.892-8.409 3.055 2.751 3.055-2.751 7.892 8.409a1.013 1.013 0 0 1-.393.077H1.507a.956.956 0 0 1-.37-.077zm15.043-9.36L24 5.174a1.691 1.691 0 0 1 .069.489v14.811a2.175 2.175 0 0 1-.069.514z"
      transform="translate(-.072 -4.068)"
      style={{ fill: "currentColor" }}
    />
  </svg>
);

export const SMSIconLarge = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      data-name="Icon material-sms"
      d="M24.6 3H5.4a2.4 2.4 0 0 0-2.388 2.4L3 27l4.8-4.8h16.8a2.407 2.407 0 0 0 2.4-2.4V5.4A2.407 2.407 0 0 0 24.6 3zM11.4 13.8H9v-2.4h2.4zm4.8 0h-2.4v-2.4h2.4zm4.8 0h-2.4v-2.4H21z"
      transform="translate(-3 -3)"
      style={{ fill: "currentcolor" }}
    />
  </svg>
);

export const IVRIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13.246"
    height="13.24"
    viewBox="0 0 13.246 13.24"
  >
    <path
      fill="#777"
      d="M17.353 14.873a11.125 11.125 0 0 0-2.324-1.555c-.7-.334-.952-.328-1.445.028-.41.3-.676.572-1.148.469a6.85 6.85 0 0 1-2.307-1.707A6.8 6.8 0 0 1 8.422 9.8c-.1-.476.176-.738.469-1.148.355-.493.365-.748.028-1.445a10.905 10.905 0 0 0-1.555-2.323c-.507-.507-.621-.4-.9-.3a5.121 5.121 0 0 0-.824.438 2.486 2.486 0 0 0-.99 1.048c-.2.424-.424 1.214.734 3.276A18.278 18.278 0 0 0 8.6 13.632a18.349 18.349 0 0 0 4.286 3.214c2.062 1.159 2.852.931 3.276.734a2.444 2.444 0 0 0 1.045-.99 5.121 5.121 0 0 0 .438-.824c.1-.272.218-.386-.292-.893z"
      opacity="0.7"
      transform="translate(-4.488 -4.5)"
    />
  </svg>
);

export const uploadFile = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="27"
    viewBox="0 0 29 27"
  >
    <g id="Icon_feather-upload" transform="translate(-3.5 -5.5)">
      <path
        id="Path_4033"
        d="M31.5 22.5v6a3 3 0 0 1-3 3h-21a3 3 0 0 1-3-3v-6"
        fill="none"
        stroke="#bebfc0"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2px"
      />
      <path
        id="Path_4034"
        d="M25.5 12L18 4.5 10.5 12"
        fill="none"
        stroke="#bebfc0"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2px"
        transform="translate(0 2)"
      />
      <path
        id="Path_4035"
        d="M18 4.5v18"
        fill="none"
        stroke="#bebfc0"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2px"
        transform="translate(0 2)"
      />
    </g>
  </svg>
);

export const rcsLivechatIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.66667 8H10.6667L8.16667 4.66667L6.16667 7.33333L4.66667 5.33333L2.66667 8ZM0 13.3333V1.33333C0 0.966667 0.130556 0.652778 0.391667 0.391667C0.652778 0.130556 0.966667 0 1.33333 0H12C12.3667 0 12.6806 0.130556 12.9417 0.391667C13.2028 0.652778 13.3333 0.966667 13.3333 1.33333V9.33333C13.3333 9.7 13.2028 10.0139 12.9417 10.275C12.6806 10.5361 12.3667 10.6667 12 10.6667H2.66667L0 13.3333Z"
      fill="#BEBFC0"
    />
  </svg>
);

export const CancelUploadIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9.417"
    height="9.417"
    viewBox="0 0 9.417 9.417"
  >
    <g id="Group_11174" transform="translate(-1306.586 -118.615)">
      <path
        id="Path_32"
        d="M5987.589 7529.029l-6.589 6.589"
        fill="none"
        stroke="#bebfc0"
        strokeLinecap="round"
        strokeWidth="2px"
        transform="translate(-4673 -7409)"
      />
      <path
        id="Path_33"
        d="M5981 7529.029l6.589 6.589"
        fill="none"
        stroke="#bebfc0"
        strokeLinecap="round"
        strokeWidth="2px"
        transform="translate(-4673 -7409)"
      />
    </g>
  </svg>
);
export const SearchIconSmall = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m11.07 9.953 4.297 4.297-1.117 1.117-4.297-4.297c-.803.578-1.77.93-2.828.93A4.875 4.875 0 1 1 12 7.125a4.817 4.817 0 0 1-.93 2.828zM7.125 3.75A3.37 3.37 0 0 0 3.75 7.125 3.37 3.37 0 0 0 7.125 10.5 3.37 3.37 0 0 0 10.5 7.125 3.37 3.37 0 0 0 7.125 3.75z"
      fill="#777"
    />
  </svg>
);

export const ReportsButtonIcon = () => {
  const color = getIconColor() || primarySvgColor;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.271"
      height="20.979"
      viewBox="0 0 17.271 20.979"
    >
      <path
        fill={color}
        d="M33.478 42.033H25.2a.7.7 0 1 1 0-1.393h8.275a.7.7 0 1 1 0 1.393zm.731 2.577a.715.715 0 0 0-.731-.7H25.2a.7.7 0 1 0 0 1.393h8.275a.715.715 0 0 0 .731-.7zm0 3.274a.715.715 0 0 0-.731-.7H25.2a.7.7 0 1 0 0 1.393h8.275a.715.715 0 0 0 .734-.693zm3.742 7.895V37.54a1.4 1.4 0 0 0-1.426-1.37H22.118a1.405 1.405 0 0 0-1.438 1.37v18.239a1.405 1.405 0 0 0 1.438 1.37h14.407a1.4 1.4 0 0 0 1.426-1.37zm-1.463 0H22.143V37.563h14.37z"
        transform="translate(-20.68 -36.17)"
      />
    </svg>
  );
};

export const MessageLogIcon = () => {
  const color = getIconColor() || primarySvgColor;
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#o8x5k10rta)">
        <path
          d="M3 9.75c.413 0 .75-.338.75-.75A.752.752 0 0 0 3 8.25a.752.752 0 0 0-.75.75c0 .412.337.75.75.75zm0 3c.413 0 .75-.338.75-.75a.752.752 0 0 0-.75-.75.752.752 0 0 0-.75.75c0 .412.337.75.75.75zm0-6c.413 0 .75-.338.75-.75A.752.752 0 0 0 3 5.25a.752.752 0 0 0-.75.75c0 .412.337.75.75.75zm3 3h9c.412 0 .75-.338.75-.75a.752.752 0 0 0-.75-.75H6a.752.752 0 0 0-.75.75c0 .412.338.75.75.75zm0 3h9c.412 0 .75-.338.75-.75a.752.752 0 0 0-.75-.75H6a.752.752 0 0 0-.75.75c0 .412.338.75.75.75zM5.25 6c0 .412.338.75.75.75h9c.412 0 .75-.338.75-.75a.752.752 0 0 0-.75-.75H6a.752.752 0 0 0-.75.75zM3 9.75c.413 0 .75-.338.75-.75A.752.752 0 0 0 3 8.25a.752.752 0 0 0-.75.75c0 .412.337.75.75.75zm0 3c.413 0 .75-.338.75-.75a.752.752 0 0 0-.75-.75.752.752 0 0 0-.75.75c0 .412.337.75.75.75zm0-6c.413 0 .75-.338.75-.75A.752.752 0 0 0 3 5.25a.752.752 0 0 0-.75.75c0 .412.337.75.75.75zm3 3h9c.412 0 .75-.338.75-.75a.752.752 0 0 0-.75-.75H6a.752.752 0 0 0-.75.75c0 .412.338.75.75.75zm0 3h9c.412 0 .75-.338.75-.75a.752.752 0 0 0-.75-.75H6a.752.752 0 0 0-.75.75c0 .412.338.75.75.75zM5.25 6c0 .412.338.75.75.75h9c.412 0 .75-.338.75-.75a.752.752 0 0 0-.75-.75H6a.752.752 0 0 0-.75.75z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="o8x5k10rta">
          <path fill="#fff" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MainLogIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.667 21.667c.916 0 1.666-.75 1.666-1.667s-.75-1.667-1.666-1.667C5.75 18.333 5 19.083 5 20s.75 1.667 1.667 1.667zm0 6.666c.916 0 1.666-.75 1.666-1.666 0-.917-.75-1.667-1.666-1.667C5.75 25 5 25.75 5 26.667c0 .916.75 1.666 1.667 1.666zm0-13.333c.916 0 1.666-.75 1.666-1.667 0-.916-.75-1.666-1.666-1.666-.917 0-1.667.75-1.667 1.666C5 14.25 5.75 15 6.667 15zm6.666 6.667h20c.917 0 1.667-.75 1.667-1.667s-.75-1.667-1.667-1.667h-20c-.916 0-1.666.75-1.666 1.667s.75 1.667 1.666 1.667zm0 6.666h20c.917 0 1.667-.75 1.667-1.666C35 25.75 34.25 25 33.333 25h-20c-.916 0-1.666.75-1.666 1.667 0 .916.75 1.666 1.666 1.666zm-1.666-15c0 .917.75 1.667 1.666 1.667h20C34.25 15 35 14.25 35 13.333c0-.916-.75-1.666-1.667-1.666h-20c-.916 0-1.666.75-1.666 1.666zm-5 8.334c.916 0 1.666-.75 1.666-1.667s-.75-1.667-1.666-1.667C5.75 18.333 5 19.083 5 20s.75 1.667 1.667 1.667zm0 6.666c.916 0 1.666-.75 1.666-1.666 0-.917-.75-1.667-1.666-1.667C5.75 25 5 25.75 5 26.667c0 .916.75 1.666 1.667 1.666zm0-13.333c.916 0 1.666-.75 1.666-1.667 0-.916-.75-1.666-1.666-1.666-.917 0-1.667.75-1.667 1.666C5 14.25 5.75 15 6.667 15zm6.666 6.667h20c.917 0 1.667-.75 1.667-1.667s-.75-1.667-1.667-1.667h-20c-.916 0-1.666.75-1.666 1.667s.75 1.667 1.666 1.667zm0 6.666h20c.917 0 1.667-.75 1.667-1.666C35 25.75 34.25 25 33.333 25h-20c-.916 0-1.666.75-1.666 1.667 0 .916.75 1.666 1.666 1.666zm-1.666-15c0 .917.75 1.667 1.666 1.667h20C34.25 15 35 14.25 35 13.333c0-.916-.75-1.666-1.667-1.666h-20c-.916 0-1.666.75-1.666 1.666z"
        fill="#777"
      />
    </svg>
  );
};

export const UploadFileIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5 11.25v2.25h-9v-2.25H3v2.25c0 .825.675 1.5 1.5 1.5h9c.825 0 1.5-.675 1.5-1.5v-2.25h-1.5zm-8.25-4.5 1.058 1.058L8.25 5.872V12h1.5V5.872l1.943 1.936L12.75 6.75 9 3 5.25 6.75z"
      fill="#777"
    />
  </svg>
);
export const SuccessMessageIcon = (
  <svg width="15.178" height="15.178" viewBox="0 0 15.178 15.178">
    <path
      fill="#00a880"
      d="M15.74 8.151A7.589 7.589 0 1 1 8.151.563a7.589 7.589 0 0 1 7.589 7.588zM7.274 12.17l5.63-5.63a.49.49 0 0 0 0-.692l-.692-.692a.49.49 0 0 0-.692 0l-4.593 4.59L4.784 7.6a.49.49 0 0 0-.692 0l-.692.695a.49.49 0 0 0 0 .692l3.181 3.183a.49.49 0 0 0 .693 0z"
      transform="translate(-.563 -.563)"
    />
  </svg>
);

export const ErrorMessageIcon = (
  <svg width="15.18" height="15.18" viewBox="0 0 15.18 15.18">
    <path
      fill="#b1203d"
      d="M15.59 8a7.59 7.59 0 1 0 7.59 7.59A7.589 7.589 0 0 0 15.59 8zm3.722 9.582a.368.368 0 0 1 0 .52l-1.212 1.21a.368.368 0 0 1-.52 0L15.59 17.3l-1.99 2.012a.368.368 0 0 1-.52 0L11.868 18.1a.368.368 0 0 1 0-.52l2.008-1.989-2.008-1.991a.368.368 0 0 1 0-.52l1.212-1.212a.368.368 0 0 1 .52 0l1.989 2.011 1.992-2.008a.368.368 0 0 1 .52 0l1.212 1.212a.368.368 0 0 1 0 .52L17.3 15.59z"
      transform="translate(-8 -8)"
    />
  </svg>
);

export const crossIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11.77"
    height="11.819"
    viewBox="0 0 11.77 11.819"
  >
    <g id="Group_57" transform="translate(1.414 1.414)">
      <path
        id="Path_32"
        d="M5989.941 7529.029l-8.94 8.991"
        fill="none"
        stroke="#adadad"
        strokeLinecap="round"
        strokeWidth="2px"
        transform="translate(-5980.999 -7529.029)"
      />
      <path
        id="Path_33"
        d="M5981 7529.029l8.939 8.991"
        fill="none"
        stroke="#adadad"
        strokeLinecap="round"
        strokeWidth="2px"
        transform="translate(-5981 -7529.029)"
      />
    </g>
  </svg>
);

export const SendLinkIcon = () => {
  // const color = getIconColor() || primarySvgColor;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18.1"
      height="9.045"
      viewBox="0 0 18.1 9.045"
    >
      <g id="Icon_feather-link-2" transform="translate(-.75 -9.75)">
        <path
          id="Path_10295"
          d="M12.064 10.5h2.264a3.773 3.773 0 0 1 0 7.546h-2.264m-4.527 0H5.273a3.773 3.773 0 1 1 0-7.546h2.263"
          fill="none"
          stroke="#777777"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5px"
        />
        <path
          id="Path_10296"
          d="M12 18h7.269"
          transform="translate(-5.834 -3.727)"
          fill="none"
          stroke="#777777"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5px"
        />
      </g>
    </svg>
  );
};

export const sendLinkChatIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18.1"
    height="9.045"
    viewBox="0 0 18.1 9.045"
  >
    <g id="Icon_feather-link-2" transform="translate(-.75 -9.75)">
      <path
        id="Path_10295"
        d="M12.064 10.5h2.264a3.773 3.773 0 0 1 0 7.546h-2.264m-4.527 0H5.273a3.773 3.773 0 1 1 0-7.546h2.263"
        fill="none"
        stroke="#777777"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5px"
      />
      <path
        id="Path_10296"
        d="M12 18h7.269"
        transform="translate(-5.834 -3.727)"
        fill="none"
        stroke="#777777"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5px"
      />
    </g>
  </svg>
);

export const ErrorYellowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.12"
    height="15.12"
    viewBox="0 0 15.12 15.12"
  >
    <path
      fill="#e2c500"
      d="M10.56 3a7.56 7.56 0 1 0 7.56 7.56A7.563 7.563 0 0 0 10.56 3zm.756 11.34H9.8v-1.512h1.512zm0-3.024H9.8V6.78h1.512z"
      transform="translate(-3 -3)"
    />
  </svg>
);
export const MultiLanguageInfoIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.16667 5.83333H10.8333V7.5H9.16667V5.83333ZM10 14.1667C10.4583 14.1667 10.8333 13.7917 10.8333 13.3333V10C10.8333 9.54167 10.4583 9.16667 10 9.16667C9.54167 9.16667 9.16667 9.54167 9.16667 10V13.3333C9.16667 13.7917 9.54167 14.1667 10 14.1667ZM10 1.66667C5.4 1.66667 1.66667 5.4 1.66667 10C1.66667 14.6 5.4 18.3333 10 18.3333C14.6 18.3333 18.3333 14.6 18.3333 10C18.3333 5.4 14.6 1.66667 10 1.66667ZM10 16.6667C6.325 16.6667 3.33333 13.675 3.33333 10C3.33333 6.325 6.325 3.33333 10 3.33333C13.675 3.33333 16.6667 6.325 16.6667 10C16.6667 13.675 13.675 16.6667 10 16.6667Z"
      fill="#BEBFC0"
    />
  </svg>
);
export const InfoIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 1.66667C5.40002 1.66667 1.66669 5.40001 1.66669 10C1.66669 14.6 5.40002 18.3333 10 18.3333C14.6 18.3333 18.3334 14.6 18.3334 10C18.3334 5.40001 14.6 1.66667 10 1.66667ZM10 14.1667C9.54169 14.1667 9.16669 13.7917 9.16669 13.3333V10C9.16669 9.54167 9.54169 9.16667 10 9.16667C10.4584 9.16667 10.8334 9.54167 10.8334 10V13.3333C10.8334 13.7917 10.4584 14.1667 10 14.1667ZM10.8334 7.50001H9.16669V5.83334H10.8334V7.50001Z"
      fill="#1890FF"
    />
  </svg>
);
export const WarningIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.47012 21H19.5301C21.0701 21 22.0301 19.33 21.2601 18L13.7301 4.98999C12.9601 3.65999 11.0401 3.65999 10.2701 4.98999L2.74012 18C1.97012 19.33 2.93012 21 4.47012 21ZM12.0001 14C11.4501 14 11.0001 13.55 11.0001 13V11C11.0001 10.45 11.4501 9.99999 12.0001 9.99999C12.5501 9.99999 13.0001 10.45 13.0001 11V13C13.0001 13.55 12.5501 14 12.0001 14ZM13.0001 18H11.0001V16H13.0001V18Z"
      fill="#E2C500"
    />
  </svg>
);
export const PromotionalIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m19 9 1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15z"
    />
  </svg>
);

export const arrowBottom = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11.122"
    height="6.359"
    viewBox="0 0 11.122 6.359"
  >
    <path
      fill="#2a2d2e"
      d="M4.442 5.559L.233 1.353a.791.791 0 0 1 0-1.123.8.8 0 0 1 1.126 0L6.127 5a.793.793 0 0 1 .023 1.1l-4.788 4.8A.795.795 0 1 1 .237 9.767z"
      transform="translate(11.122) rotate(90)"
    />
  </svg>
);

export const validPreviewIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
  >
    <path
      fill="#00a87e"
      d="M13.563 7.063a6.5 6.5 0 1 1-6.5-6.5 6.5 6.5 0 0 1 6.5 6.5zM6.311 10.5l4.823-4.823a.419.419 0 0 0 0-.593L10.54 4.5a.419.419 0 0 0-.593 0L6.014 8.428 4.178 6.592a.419.419 0 0 0-.593 0l-.593.593a.419.419 0 0 0 0 .593L5.718 10.5a.419.419 0 0 0 .593 0z"
      transform="translate(-.563 -.563)"
    />
  </svg>
);

export const invalidPreviewIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
  >
    <path
      fill="#b1203d"
      d="M9.5 3A6.5 6.5 0 1 0 16 9.5 6.5 6.5 0 0 0 9.5 3zm.65 9.75h-1.3v-1.3h1.3zm0-2.6h-1.3v-3.9h1.3z"
      transform="translate(-3 -3)"
    />
  </svg>
);

export const closeChatLink = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11.77"
    height="11.819"
    viewBox="0 0 11.77 11.819"
  >
    <g id="Group_57" transform="translate(1.414 1.414)">
      <path
        id="Path_32"
        d="M5989.941 7529.029l-8.94 8.991"
        fill="none"
        stroke="#adadad"
        strokeLinecap="round"
        strokeWidth="2px"
        transform="translate(-5980.999 -7529.029)"
      />
      <path
        id="Path_33"
        d="M5981 7529.029l8.939 8.991"
        fill="none"
        stroke="#adadad"
        strokeLinecap="round"
        strokeWidth="2px"
        transform="translate(-5981 -7529.029)"
      />
    </g>
  </svg>
);

export const cloackIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.695"
    height="16.531"
    viewBox="0 0 15.695 16.531"
  >
    <g id="Group_11427" transform="translate(-1247.966 -239.009)">
      <path
        id="Union_6"
        fill="none"
        stroke="#fff"
        strokeWidth="1.4px"
        d="M.427 8.335a6.954 6.954 0 1 1 6.956 6.955A6.963 6.963 0 0 1 .427 8.335zM11.912 0L14.8 2.387zM2.887 0L0 2.387z"
        transform="translate(1248.411 239.55)"
      />
      <g id="Group_11426" transform="translate(1253.351 246.048)">
        <path
          id="Path_10347"
          d="M0 0v4.866"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="1.2px"
          transform="translate(5.199 0) rotate(45)"
        />
        <path
          id="Path_10346"
          d="M0 0l1.758 1.77"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="1.2px"
          transform="translate(0 1.671)"
        />
      </g>
    </g>
  </svg>
);

export const ActionsButtonIcon = () => {
  const color = getIconColor() || primarySvgColor;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 4.278 20.218"
    >
      <g
        id="Icon_feather-more-vertical"
        data-name="Icon feather-more-vertical"
        transform="translate(-15.499 -5)"
      >
        <path
          id="Path_4088"
          data-name="Path 4088"
          d="M18.777,17.639A1.139,1.139,0,1,1,17.639,16.5,1.139,1.139,0,0,1,18.777,17.639Z"
          transform="translate(0 -2.53)"
          fill={color}
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_4089"
          data-name="Path 4089"
          d="M18.777,7.139A1.139,1.139,0,1,1,17.639,6,1.139,1.139,0,0,1,18.777,7.139Z"
          fill={color}
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_4090"
          data-name="Path 4090"
          d="M18.777,28.139A1.139,1.139,0,1,1,17.639,27a1.139,1.139,0,0,1,1.138,1.139Z"
          transform="translate(0 -5.06)"
          fill={color}
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export const deleteIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10.8"
    height="13.295"
    viewBox="0 0 10.8 13.295"
  >
    <path
      fill="#b1203d"
      d="M32.132 6.965a.311.311 0 0 0-.312.311v5.881a.312.312 0 0 0 .622 0V7.274a.311.311 0 0 0-.312-.311zm-3.674 0a.311.311 0 0 0-.312.311v5.881a.312.312 0 1 0 .622 0V7.274a.311.311 0 0 0-.312-.311zm-2.678-.858v7.671a1.72 1.72 0 0 0 .453 1.184 1.539 1.539 0 0 0 1.111.483h5.892a1.539 1.539 0 0 0 1.112-.481 1.72 1.72 0 0 0 .452-1.184V6.107a1.189 1.189 0 0 0-.3-2.34h-1.587v-.394A1.223 1.223 0 0 0 31.7 2.15h-2.787a1.223 1.223 0 0 0-1.234 1.216v.4h-1.594a1.189 1.189 0 0 0-.306 2.34zm7.46 8.713h-5.9a.985.985 0 0 1-.947-1.026v-7.66h7.785v7.644a.986.986 0 0 1-.923 1.043zM28.3 3.38a.6.6 0 0 1 .6-.609h2.777a.6.6 0 0 1 .61.591v.4H28.3zm-2.214 1.007h8.42a.561.561 0 0 1 0 1.121h-8.42a.561.561 0 1 1 0-1.121zM30.3 6.965a.311.311 0 0 0-.312.311v5.881a.312.312 0 1 0 .622 0V7.274a.311.311 0 0 0-.312-.311z"
      transform="translate(-24.89 -2.15)"
    />
  </svg>
);

export const smsIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13">
    <path
      data-name="Icon material-sms"
      d="M14.7 3H4.3a1.3 1.3 0 0 0-1.294 1.3L3 16l2.6-2.6h9.1a1.3 1.3 0 0 0 1.3-1.3V4.3A1.3 1.3 0 0 0 14.7 3zM7.549 8.849H6.25v-1.3h1.3zm2.6 0h-1.3v-1.3h1.3zm2.6 0h-1.3v-1.3h1.3z"
      transform="translate(-3 -3)"
      style={{ fill: "#777", opacity: ".7" }}
    />
  </svg>
);

export const callIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="13.246" height="13.24">
    <path
      data-name="Icon ionic-ios-call"
      d="M17.353 14.873a11.125 11.125 0 0 0-2.324-1.555c-.7-.334-.952-.328-1.445.028-.41.3-.676.572-1.148.469a6.85 6.85 0 0 1-2.307-1.707A6.8 6.8 0 0 1 8.422 9.8c-.1-.476.176-.738.469-1.148.355-.493.365-.748.028-1.445a10.905 10.905 0 0 0-1.555-2.323c-.507-.507-.621-.4-.9-.3a5.121 5.121 0 0 0-.824.438 2.486 2.486 0 0 0-.99 1.048c-.2.424-.424 1.214.734 3.276A18.278 18.278 0 0 0 8.6 13.632a18.349 18.349 0 0 0 4.286 3.214c2.062 1.159 2.852.931 3.276.734a2.444 2.444 0 0 0 1.045-.99 5.121 5.121 0 0 0 .438-.824c.1-.272.218-.386-.292-.893z"
      transform="translate(-4.488 -4.5)"
      style={{ fill: "#777", opacity: ".7" }}
    />
  </svg>
);

export const emailIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_52360_24209)">
      <path
        d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM19.6 8.25L12.53 12.67C12.21 12.87 11.79 12.87 11.47 12.67L4.4 8.25C4.15 8.09 4 7.82 4 7.53C4 6.86 4.73 6.46 5.3 6.81L12 11L18.7 6.81C19.27 6.46 20 6.86 20 7.53C20 7.82 19.85 8.09 19.6 8.25Z"
        fill="#BEBFC0"
      />
    </g>
    <defs>
      <clipPath id="clip0_52360_24209">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const rcsIcon = (
  <svg
    width="17"
    height="18"
    viewBox="0 0 21.5 21.5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.99984 11.6667H14.9998L11.8748 7.50001L9.37484 10.8333L7.49984 8.33334L4.99984 11.6667ZM1.6665 18.3333V3.33334C1.6665 2.87501 1.8297 2.48264 2.15609 2.15626C2.48248 1.82987 2.87484 1.66667 3.33317 1.66667H16.6665C17.1248 1.66667 17.5172 1.82987 17.8436 2.15626C18.17 2.48264 18.3332 2.87501 18.3332 3.33334V13.3333C18.3332 13.7917 18.17 14.184 17.8436 14.5104C17.5172 14.8368 17.1248 15 16.6665 15H4.99984L1.6665 18.3333Z"
      style={{ fill: "#777", opacity: ".7" }}
    />
  </svg>
);

export const rcsIconMain = (
  <svg
    width="17"
    height="18"
    viewBox="0 0 21.5 21.5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.99984 11.6667H14.9998L11.8748 7.50001L9.37484 10.8333L7.49984 8.33334L4.99984 11.6667ZM1.6665 18.3333V3.33334C1.6665 2.87501 1.8297 2.48264 2.15609 2.15626C2.48248 1.82987 2.87484 1.66667 3.33317 1.66667H16.6665C17.1248 1.66667 17.5172 1.82987 17.8436 2.15626C18.17 2.48264 18.3332 2.87501 18.3332 3.33334V13.3333C18.3332 13.7917 18.17 14.184 17.8436 14.5104C17.5172 14.8368 17.1248 15 16.6665 15H4.99984L1.6665 18.3333Z"
      style={{ fill: "#00B2E3", opacity: ".7" }}
    />
  </svg>
);

export const EditIcon = () => {
  const color = getIconColor() || primarySvgColor;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13.181" height="13.178">
      <path
        data-name="edit"
        d="M4.5 14.71v2.7h2.7l7.954-7.955-2.7-2.7zm11.971-6.574a.716.716 0 0 0 0-1.014l-1.685-1.683a.716.716 0 0 0-1.014 0L12.456 6.75l2.7 2.7z"
        transform="translate(-4 -4.729)"
        style={{ fill: "none", stroke: color }}
      />
    </svg>
  );
};

export const TranslatePreviewIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5148 15.1968L11.8239 17.0304C11.7713 17.169 11.6814 17.282 11.5544 17.3692C11.4274 17.4564 11.2876 17.5 11.1352 17.5C10.8759 17.5 10.6696 17.3969 10.5162 17.1907C10.3629 16.9844 10.3353 16.7563 10.4334 16.5064L13.3513 8.96989C13.4156 8.83241 13.5115 8.72006 13.6388 8.63285C13.7662 8.54564 13.9063 8.50204 14.0592 8.50204H14.6324C14.7853 8.50204 14.9245 8.54585 15.0499 8.63346C15.1754 8.72108 15.2695 8.83374 15.3322 8.97142L18.2753 16.5253C18.3735 16.7627 18.3467 16.9845 18.1949 17.1907C18.0432 17.3969 17.8389 17.5 17.5822 17.5C17.4153 17.5 17.2684 17.4551 17.1415 17.3653C17.0145 17.2755 16.9204 17.1519 16.859 16.9947L16.2275 15.1968H12.5148ZM12.9669 13.8886H15.7315L14.3842 10.1796H14.3072L12.9669 13.8886ZM7.816 11.498L4.50478 14.7196C4.35595 14.8581 4.17551 14.9291 3.96345 14.9324C3.75141 14.9358 3.57443 14.8666 3.43252 14.7247C3.29062 14.5828 3.22141 14.4067 3.22488 14.1963C3.22834 13.986 3.30065 13.8121 3.4418 13.6748L6.79095 10.4155C6.29696 9.88546 5.86992 9.34084 5.50983 8.78164C5.14974 8.22243 4.83393 7.62991 4.56241 7.00406H6.17079C6.40552 7.44872 6.65385 7.85315 6.91578 8.21736C7.17772 8.58157 7.49006 8.96205 7.85281 9.35879C8.41959 8.75998 8.88977 8.14559 9.26335 7.5156C9.63691 6.88561 9.95332 6.21578 10.2126 5.5061H2.43642C2.21826 5.5061 2.03541 5.43217 1.88785 5.2843C1.74029 5.13642 1.6665 4.95666 1.6665 4.74501C1.6665 4.53334 1.74226 4.35592 1.89376 4.21274C2.04526 4.06957 2.22961 3.99798 2.44683 3.99798H7.04679V3.24899C7.04679 3.03677 7.12026 2.85889 7.2672 2.71534C7.41414 2.57178 7.59622 2.5 7.81344 2.5C8.03066 2.5 8.21285 2.57178 8.36 2.71534C8.50716 2.85889 8.58074 3.03677 8.58074 3.24899V3.99798H13.1873C13.4049 3.99798 13.5872 4.06975 13.7344 4.2133C13.8815 4.35686 13.9551 4.53475 13.9551 4.74697C13.9551 4.95731 13.8816 5.13642 13.7345 5.2843C13.5874 5.43217 13.4051 5.5061 13.1877 5.5061H11.7474C11.4758 6.38343 11.1071 7.24358 10.6411 8.08654C10.1751 8.92951 9.6031 9.7178 8.92507 10.4514L10.7751 12.2829L10.2126 13.8168L7.816 11.498Z"
        fill="#00A880"
      />
    </svg>
  );
};

export const SidenavEditIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13.181" height="13.178">
      <path
        data-name="edit"
        d="M4.5 14.71v2.7h2.7l7.954-7.955-2.7-2.7zm11.971-6.574a.716.716 0 0 0 0-1.014l-1.685-1.683a.716.716 0 0 0-1.014 0L12.456 6.75l2.7 2.7z"
        transform="translate(-4 -4.729)"
        style={{ fill: "#575a5c", stroke: "#f2f1f0" }}
      />
    </svg>
  );
};

export const redCrossIcon = (
  <svg width="9.792" height="9.792">
    <g
      id="Group_11537"
      data-name="Group 11537"
      transform="translate(-900.078 -545.261)"
    >
      <path
        id="Path_153"
        data-name="Path 153"
        style={{
          fill: "none",
          stroke: "#b1203d",
          strokeLinecap: "round",
          strokeWidth: "1.6px",
        }}
        d="m807.973 7758.16 7.528 7.527"
        transform="translate(93.237 -7211.766)"
      />
      <path
        id="Path_154"
        data-name="Path 154"
        style={{
          fill: "none",
          stroke: "#b1203d",
          strokeLinecap: "round",
          strokeWidth: "1.6px",
        }}
        d="m815.5 7758.16-7.528 7.526"
        transform="translate(93.237 -7211.768)"
      />
    </g>
  </svg>
);

export const TickIcon = () => {
  const color = getIconColor() || primarySvgColor;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13.185" height="9.213">
      <path
        d="m0 3.641 3.641 3.641L10.922 0"
        transform="translate(1.131 1.131)"
        style={{
          fill: "none",
          stroke: color,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeMiterLimit: "10",
          strokeWidth: "1.6px",
        }}
      />
    </svg>
  );
};

export const CopyIcon = (
  <svg width="11.705" height="13.905" viewBox="0 0 11.705 13.905">
    <path
      fill="#adadad"
      d="M7.36 13.9H2.173A2.175 2.175 0 0 1 0 11.732v-7.36A2.175 2.175 0 0 1 2.173 2.2H7.36a2.175 2.175 0 0 1 2.172 2.172v7.36A2.175 2.175 0 0 1 7.36 13.9zM2.173 3.286a1.088 1.088 0 0 0-1.087 1.086v7.36a1.088 1.088 0 0 0 1.086 1.086H7.36a1.088 1.088 0 0 0 1.086-1.086v-7.36A1.088 1.088 0 0 0 7.36 3.286zm9.532 7.088v-8.2A2.175 2.175 0 0 0 9.532 0H3.5a.543.543 0 1 0 0 1.086h6.032a1.088 1.088 0 0 1 1.086 1.086v8.2a.543.543 0 0 0 1.086 0zm0 0"
    />
  </svg>
);

export const autoIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="14.511"
    viewBox="0 0 13 14.511"
  >
    <g id="Group_11667" data-name="Group 11667" transform="translate(-1.25)">
      <path
        id="Path_10413"
        data-name="Path 10413"
        d="M14.25,10.13V4.379a1.689,1.689,0,0,0-.761-1.319h0L8.512.181a1.689,1.689,0,0,0-1.523,0L2.011,3.06A1.689,1.689,0,0,0,1.25,4.381v5.752a1.685,1.685,0,0,0,.761,1.319L6.989,14.33a1.689,1.689,0,0,0,1.523,0l4.977-2.885A1.68,1.68,0,0,0,14.25,10.13Zm-4.427.221-.415-.837H6.084l-.407.837H3.693L6.954,3.676a.878.878,0,0,1,.8-.545.9.9,0,0,1,.8.539l3.261,6.681Z"
        fill="#777"
      />
      <path
        id="Path_10414"
        data-name="Path 10414"
        d="M10.527,13.124h2.945L12,10.075Z"
        transform="translate(-4.25 -4.563)"
        fill="#777"
      />
    </g>
  </svg>
);

export const selectedFile = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17.271"
    height="20.979"
    viewBox="0 0 17.271 20.979"
  >
    <path
      fill="#fff"
      d="M33.478 42.033H25.2a.7.7 0 1 1 0-1.393h8.275a.7.7 0 1 1 0 1.393zm.731 2.577a.715.715 0 0 0-.731-.7H25.2a.7.7 0 1 0 0 1.393h8.275a.715.715 0 0 0 .731-.7zm0 3.274a.715.715 0 0 0-.731-.7H25.2a.7.7 0 1 0 0 1.393h8.275a.715.715 0 0 0 .734-.693zm3.742 7.895V37.54a1.4 1.4 0 0 0-1.426-1.37H22.118a1.405 1.405 0 0 0-1.438 1.37v18.239a1.405 1.405 0 0 0 1.438 1.37h14.407a1.4 1.4 0 0 0 1.426-1.37zm-1.463 0H22.143V37.563h14.37z"
      transform="translate(-20.68 -36.17)"
    />
  </svg>
);

export const MickIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="19"
    viewBox="0 0 15.364 23"
  >
    <g
      id="Icon_feather-mic"
      data-name="Icon feather-mic"
      transform="translate(-6.5 -0.5)"
    >
      <path
        id="Path_10382"
        data-name="Path 10382"
        d="M16.364,1.5A2.864,2.864,0,0,0,13.5,4.364V12a2.864,2.864,0,1,0,5.727,0V4.364A2.864,2.864,0,0,0,16.364,1.5Z"
        transform="translate(-2.182)"
        fill="none"
        stroke="#00b2e3"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <path
        id="Path_10383"
        data-name="Path 10383"
        d="M20.864,15v1.909a6.682,6.682,0,1,1-13.364,0V15"
        transform="translate(0 -4.909)"
        fill="none"
        stroke="#00b2e3"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <path
        id="Path_10384"
        data-name="Path 10384"
        d="M18,28.5v3.818"
        transform="translate(-3.818 -9.818)"
        fill="none"
        stroke="#00b2e3"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <path
        id="Path_10385"
        data-name="Path 10385"
        d="M12,34.5h7.636"
        transform="translate(-1.636 -12)"
        fill="none"
        stroke="#00b2e3"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
    </g>
  </svg>
);

export const SaveIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="19"
    viewBox="0 0 21 22"
  >
    <g
      id="Icon_feather-save"
      data-name="Icon feather-save"
      transform="translate(-3.5 -3.5)"
    >
      <path
        id="Path_10379"
        data-name="Path 10379"
        d="M21.278,24.5H6.722A2.222,2.222,0,0,1,4.5,22.278V6.722A2.222,2.222,0,0,1,6.722,4.5H18.944L23.5,10.056V22.278A2.222,2.222,0,0,1,21.278,24.5Z"
        fill="none"
        stroke="#00b2e3"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <path
        id="Path_10380"
        data-name="Path 10380"
        d="M20.828,28.389V19.5H10.5v8.889"
        transform="translate(-1.556 -3.889)"
        fill="none"
        stroke="#00b2e3"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <path
        id="Path_10381"
        data-name="Path 10381"
        d="M10.5,4.5v5.556h8.889"
        transform="translate(-1.556)"
        fill="none"
        stroke="#00b2e3"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
    </g>
  </svg>
);

export const playIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34.875"
    height="34.875"
    viewBox="0 0 34.875 34.875"
  >
    <path
      id="Icon_awesome-play-circle"
      data-name="Icon awesome-play-circle"
      d="M18,.563A17.438,17.438,0,1,0,35.438,18,17.434,17.434,0,0,0,18,.563Zm8.135,19.125-12.375,7.1a1.691,1.691,0,0,1-2.51-1.477V10.688a1.692,1.692,0,0,1,2.51-1.477l12.375,7.523A1.693,1.693,0,0,1,26.135,19.688Z"
      transform="translate(-0.563 -0.563)"
      fill="#00b2e3"
    />
  </svg>
);

export const pauseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34.875"
    height="34.875"
    viewBox="0 0 34.875 34.875"
  >
    <path
      id="Icon_material-pause-circle-filled"
      data-name="Icon material-pause-circle-filled"
      d="M20.438,3A17.438,17.438,0,1,0,37.875,20.438,17.444,17.444,0,0,0,20.438,3ZM18.694,27.413H15.206V13.463h3.488Zm6.975,0H22.181V13.463h3.488Z"
      transform="translate(-3 -3)"
      fill="#1db2e3"
    />
  </svg>
);

export const FileIcon = () => {
  const color = getIconColor() || primarySvgColor;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28.599"
      height="36.415"
      viewBox="0 0 29.599 38.415"
    >
      <g data-name="Icon feather-file">
        <path
          data-name="Path 10395"
          d="M21.525 3H9.45A3.55 3.55 0 0 0 6 6.642v29.132a3.55 3.55 0 0 0 3.45 3.642h20.7a3.55 3.55 0 0 0 3.45-3.642V13.19z"
          transform="translate(-5 -2)"
          stroke-linejoin="round"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-width="2px"
        />
        <path
          data-name="Path 10396"
          d="M19.5 6v9.376h10.976"
          transform="translate(-1.975 -3.839)"
          stroke-linejoin="round"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-width="2px"
        />
        <g data-name="Group 11738">
          <path
            data-name="Line 115"
            transform="translate(8.501 19.5)"
            fill="none"
            stroke={color}
            stroke-linecap="round"
            stroke-width="2px"
            d="M0 0h13.383"
          />
          <path
            data-name="Line 116"
            transform="translate(8.501 25.5)"
            fill="none"
            stroke={color}
            stroke-linecap="round"
            stroke-width="2px"
            d="M0 0h13.383"
          />
        </g>
      </g>
    </svg>
  );
};

//Grey Circle with ! in it
export const ErrorDropdownIcon = ({ color = "#e6e6e6", size = "41.332" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 41.332 41.332"
    >
      <path
        data-name="Icon material-error-outline"
        d="M21.6 29.866h4.133V34H21.6zm0-16.533h4.133v12.4H21.6zM23.645 3a20.656 20.656 0 1 0 14.63 6.043A20.666 20.666 0 0 0 23.645 3zm.021 37.2A16.533 16.533 0 1 1 40.2 23.666 16.533 16.533 0 0 1 23.666 40.2z"
        transform="translate(-3 -3)"
        style={{ fill: color }}
      />
    </svg>
  );
};

export const SearchDropdownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.49"
      height="14.492"
      viewBox="0 0 14.49 14.492"
    >
      <path
        fill="#ddd"
        d="M14.293 12.53l-2.822-2.822a.679.679 0 0 0-.481-.2h-.461a5.884 5.884 0 1 0-1.019 1.021v.461a.679.679 0 0 0 .2.481l2.822 2.822a.676.676 0 0 0 .959 0l.8-.8a.682.682 0 0 0 0-.962zM5.887 9.51A3.623 3.623 0 1 1 9.51 5.887 3.621 3.621 0 0 1 5.887 9.51z"
      />
    </svg>
  );
};

export const SmallCloseIcon = ({ onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
    >
      <path
        data-name="Icon material-close"
        d="m15.5 8.306-.806-.806-3.194 3.194L8.306 7.5l-.806.806 3.194 3.194L7.5 14.694l.806.806 3.194-3.194 3.194 3.194.806-.806-3.194-3.194z"
        transform="translate(-7.5 -7.5)"
        style={{ fill: "#777" }}
      />
    </svg>
  );
};

export const ArrowDown = ({ color = "#fff", ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8.27"
    height="4.728"
    viewBox="0 0 8.27 4.728"
    {...rest}
  >
    <path
      fill={color}
      d="M3.3 4.133L.174 1.006a.588.588 0 0 1 0-.835.6.6 0 0 1 .837 0l3.545 3.544a.59.59 0 0 1 .017.815L1.013 8.1a.591.591 0 0 1-.837-.835z"
      transform="rotate(90 4.135 4.135)"
    />
  </svg>
);

export const PreviewIcon = () => {
  const color = getIconColor() || "#00B4E5";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.428"
      height="12"
      viewBox="0 0 15.428 12"
    >
      <path
        d="M4.286 38a3.429 3.429 0 1 1 3.429 3.429A3.428 3.428 0 0 1 4.286 38zm3.429 2.143a2.143 2.143 0 0 0 0-4.286h-.079a1.067 1.067 0 0 1 .078.429A1.716 1.716 0 0 1 6 38a1.067 1.067 0 0 1-.429-.078v.054a2.148 2.148 0 0 0 2.143 2.167zm-5.159-5.984A7.54 7.54 0 0 1 7.714 32a7.542 7.542 0 0 1 5.159 2.159 10.377 10.377 0 0 1 2.488 3.512.852.852 0 0 1 0 .659 10.86 10.86 0 0 1-2.488 3.512A7.537 7.537 0 0 1 7.714 44a7.535 7.535 0 0 1-5.158-2.159 10.9 10.9 0 0 1-2.49-3.512.856.856 0 0 1 0-.659 10.415 10.415 0 0 1 2.49-3.512zm5.158-.873A6.27 6.27 0 0 0 3.431 35.1 9.244 9.244 0 0 0 1.324 38a9.522 9.522 0 0 0 2.107 2.9 6.27 6.27 0 0 0 4.283 1.813A6.27 6.27 0 0 0 12 40.9a9.969 9.969 0 0 0 2.105-2.9A9.664 9.664 0 0 0 12 35.1a6.27 6.27 0 0 0-4.283-1.813z"
        transform="translate(0 -32)"
        style={{ fill: color }}
      />
    </svg>
  );
};

export const ChatNotify = () => {
  const color = getIconColor() || "#00B4E5";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="37"
      viewBox="0 0 37 37"
    >
      <g data-name="Group 11958" transform="translate(-1132.438)">
        <circle
          data-name="Ellipse 610"
          cx="18"
          cy="18"
          r="18"
          transform="translate(1132.438)"
          style={{ fill: "rgba(0, 180, 225, 0.1)" }}
        />
        <g data-name="Group 12006">
          <path
            data-name="Union 8"
            d="M.007 1.6A1.6 1.6 0 0 1 1.6 0h12.8A1.6 1.6 0 0 1 16 1.6v9.6a1.6 1.6 0 0 1-1.6 1.6H3.2L0 16z"
            transform="translate(1142.938 11.896)"
            style={{ fill: color }}
          />
          <path
            data-name="Union 9"
            d="M0 4.461v-.636h8.285v.636zM0 2.55v-.637h8.285v.637zM0 .638V0h8.285v.638z"
            transform="translate(1146.763 15.786)"
            style={{ fill: "#fff" }}
          />
        </g>
      </g>
    </svg>
  );
};

export const BellIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.126"
      height="15"
      viewBox="0 0 13.126 15"
    >
      <path
        d="M7.5.938V1.5a4.69 4.69 0 0 1 3.75 4.594v.551a5.633 5.633 0 0 0 1.421 3.738l.217.243a.938.938 0 0 1-.7 1.562H.938a.938.938 0 0 1-.7-1.562l.217-.243a5.627 5.627 0 0 0 1.42-3.738v-.551A4.664 4.664 0 0 1 5.625 1.5V.938a.937.937 0 1 1 1.875 0zM6.563 15a1.876 1.876 0 0 1-1.327-.548 1.922 1.922 0 0 1-.548-1.327h3.75A1.871 1.871 0 0 1 6.563 15z"
        data-name="Group 11334"
      />
    </svg>
  );
};

export const AgentNotify = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="37"
      viewBox="0 0 37 37"
    >
      <g data-name="Group 11958" transform="translate(-1132.438)">
        <circle
          data-name="Ellipse 610"
          cx="18"
          cy="18"
          r="18"
          transform="translate(1132.438)"
          style={{ fill: "rgba(119,119,119,.1)" }}
        />
        <path
          data-name="Icon material-sms"
          d="M16.5 3h-12a1.5 1.5 0 0 0-1.493 1.5L3 18l3-3h10.5a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 16.5 3zM8.249 9.749H6.75v-1.5h1.5zm3 0h-1.5v-1.5h1.5zm3 0h-1.5v-1.5h1.5z"
          transform="translate(1140.438 8)"
          style={{ fill: "#777" }}
        />
      </g>
    </svg>
  );
};

export const LiveChatLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25.104"
      height="25.104"
      viewBox="0 0 25.104 25.104"
    >
      <g data-name="Group 11958">
        <path
          data-name="Icon material-sms"
          d="M25.593 3H5.51a2.51 2.51 0 0 0-2.5 2.51L3 28.1l5.021-5.021h17.572a2.51 2.51 0 0 0 2.51-2.51V5.51A2.51 2.51 0 0 0 25.593 3zM11.784 14.295H9.276v-2.51h2.51zm5.021 0h-2.51v-2.51h2.51zm5.021 0h-2.51v-2.51h2.51z"
          transform="translate(-3 -3)"
          style={{ fill: "#777" }}
        />
        <path
          data-name="Rectangle 3193"
          transform="translate(5 8.103)"
          style={{ fill: "#777" }}
          d="M0 0h15v4H0z"
        />
        <path
          data-name="Rectangle 3194"
          transform="translate(6 6.103)"
          style={{ fill: "#fff" }}
          d="M0 0h13v1H0z"
        />
        <path
          data-name="Rectangle 3195"
          transform="translate(6 9.103)"
          style={{ fill: "#fff" }}
          d="M0 0h13v1H0z"
        />
        <path
          data-name="Rectangle 3196"
          transform="translate(6 12.103)"
          style={{ fill: "#fff" }}
          d="M0 0h13v1H0z"
        />
      </g>
    </svg>
  );
};

export const LiveAgentLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25.104"
      height="25.104"
      viewBox="0 0 25.104 25.104"
    >
      <g data-name="Group 11958">
        <path
          data-name="Icon material-sms"
          d="M25.593 3H5.51a2.51 2.51 0 0 0-2.5 2.51L3 28.1l5.021-5.021h17.572a2.51 2.51 0 0 0 2.51-2.51V5.51A2.51 2.51 0 0 0 25.593 3zM11.784 14.295H9.276v-2.51h2.51zm5.021 0h-2.51v-2.51h2.51zm5.021 0h-2.51v-2.51h2.51z"
          transform="translate(-3 -3)"
          style={{ fill: "#777" }}
        />
      </g>
    </svg>
  );
};

export const secureMsgIcon = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#xrs3afqwua)">
      <path
        d="M9 4h-.5V3a2.5 2.5 0 0 0-5 0v1H3c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zM6 8.5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM4.5 4V3c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v1h-3z"
        fill="#00B2E3"
      />
    </g>
    <defs>
      <clipPath id="xrs3afqwua">
        <path fill="#fff" d="M0 0h12v12H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const unencryptedMsgIcon = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#ck0yrs18ya)">
      <path
        d="M6 6.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM9 4h-.5V3a2.5 2.5 0 0 0-4.92-.625.5.5 0 1 0 .97.25A1.498 1.498 0 0 1 7.5 3v1H3c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm0 5.5c0 .275-.225.5-.5.5h-5a.501.501 0 0 1-.5-.5v-4c0-.275.225-.5.5-.5h5c.275 0 .5.225.5.5v4z"
        fill="#B1203D"
      />
    </g>
    <defs>
      <clipPath id="ck0yrs18ya">
        <path fill="#fff" d="M0 0h12v12H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const secureLinkIcon = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.875 8h-5.29C2.54 8 1.61 7.235 1.51 6.195A2 2 0 0 1 3.5 4h6.18c.655 0 1.25.47 1.315 1.12A1.25 1.25 0 0 1 9.75 6.5H4.5A.501.501 0 0 1 4 6c0-.275.225-.5.5-.5h4.375c.205 0 .375-.17.375-.375a.378.378 0 0 0-.375-.375H4.57c-.655 0-1.25.47-1.315 1.12A1.25 1.25 0 0 0 4.5 7.25h5.165c1.045 0 1.975-.765 2.075-1.805A1.997 1.997 0 0 0 9.75 3.25H3.615C2.18 3.25.895 4.3.76 5.73A2.753 2.753 0 0 0 3.5 8.75h5.375c.205 0 .375-.17.375-.375A.378.378 0 0 0 8.875 8z"
      fill="#2A2D2E"
    />
  </svg>
);

export const PatientReport = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.86 5.752H6.13a.505.505 0 0 1 0-1.01h5.728a.505.505 0 1 1 0 1.01h.002zm.506 1.87a.506.506 0 0 0-.506-.506H6.13a.505.505 0 0 0 0 1.01h5.728a.506.506 0 0 0 .506-.505h.002zm0 2.374a.506.506 0 0 0-.506-.505H6.13a.505.505 0 1 0 0 1.01h5.728a.506.506 0 0 0 .508-.504v-.001zm2.59 5.726V2.493a.994.994 0 0 0-.986-.993H3.996A.995.995 0 0 0 3 2.493v13.23a.995.995 0 0 0 .996.993h9.974a.995.995 0 0 0 .987-.993zm-1.012 0H4.013V2.511h9.948l-.017 13.211z"
      fill="#777"
    />
  </svg>
);

export const LogIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#9p6ok351ka)">
      <path
        d="M3 9.75c.413 0 .75-.338.75-.75A.752.752 0 0 0 3 8.25a.752.752 0 0 0-.75.75c0 .412.337.75.75.75zm0 3c.413 0 .75-.338.75-.75a.752.752 0 0 0-.75-.75.752.752 0 0 0-.75.75c0 .412.337.75.75.75zm0-6c.413 0 .75-.338.75-.75A.752.752 0 0 0 3 5.25a.752.752 0 0 0-.75.75c0 .412.337.75.75.75zm3 3h9c.412 0 .75-.338.75-.75a.752.752 0 0 0-.75-.75H6a.752.752 0 0 0-.75.75c0 .412.338.75.75.75zm0 3h9c.412 0 .75-.338.75-.75a.752.752 0 0 0-.75-.75H6a.752.752 0 0 0-.75.75c0 .412.338.75.75.75zM5.25 6c0 .412.338.75.75.75h9c.412 0 .75-.338.75-.75a.752.752 0 0 0-.75-.75H6a.752.752 0 0 0-.75.75zM3 9.75c.413 0 .75-.338.75-.75A.752.752 0 0 0 3 8.25a.752.752 0 0 0-.75.75c0 .412.337.75.75.75zm0 3c.413 0 .75-.338.75-.75a.752.752 0 0 0-.75-.75.752.752 0 0 0-.75.75c0 .412.337.75.75.75zm0-6c.413 0 .75-.338.75-.75A.752.752 0 0 0 3 5.25a.752.752 0 0 0-.75.75c0 .412.337.75.75.75zm3 3h9c.412 0 .75-.338.75-.75a.752.752 0 0 0-.75-.75H6a.752.752 0 0 0-.75.75c0 .412.338.75.75.75zm0 3h9c.412 0 .75-.338.75-.75a.752.752 0 0 0-.75-.75H6a.752.752 0 0 0-.75.75c0 .412.338.75.75.75zM5.25 6c0 .412.338.75.75.75h9c.412 0 .75-.338.75-.75a.752.752 0 0 0-.75-.75H6a.752.752 0 0 0-.75.75z"
        fill="#777"
      />
    </g>
    <defs>
      <clipPath id="9p6ok351ka">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const downloadArrow = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3h-2zm-1-4-1.41-1.41L13 12.17V4h-2v8.17L8.41 9.59 7 11l5 5 5-5z"
      fill="#00B2E3"
    />
  </svg>
);
export const downloadArrowVeradigm = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3h-2zm-1-4-1.41-1.41L13 12.17V4h-2v8.17L8.41 9.59 7 11l5 5 5-5z"
      fill="#403c7e"
    />
  </svg>
);

export const cernerDownloadArrow = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3h-2zm-1-4-1.41-1.41L13 12.17V4h-2v8.17L8.41 9.59 7 11l5 5 5-5z"
      fill="#FFFFFF"
    />
  </svg>
);

export const sideNavMail = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.333 2.667H2.667c-.734 0-1.327.6-1.327 1.333l-.007 8c0 .734.6 1.334 1.334 1.334h10.666c.734 0 1.334-.6 1.334-1.334V4c0-.733-.6-1.333-1.334-1.333zm0 9.333H2.667V5.334L8 8.667l5.333-3.333V12zM8 7.334 2.667 4h10.666L8 7.334z"
      fill="#BEBFC0"
    />
  </svg>
);

export const SideNavFilter = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#5ou6c0wz7a)">
      <path
        d="M7.333 12h1.334c.366 0 .666-.3.666-.667 0-.366-.3-.666-.666-.666H7.333c-.366 0-.666.3-.666.666 0 .367.3.667.666.667zM2 4.667c0 .366.3.666.667.666h10.666c.367 0 .667-.3.667-.666C14 4.3 13.7 4 13.333 4H2.667C2.3 4 2 4.3 2 4.667zm2.667 4h6.666c.367 0 .667-.3.667-.667 0-.367-.3-.667-.667-.667H4.667C4.3 7.333 4 7.633 4 8c0 .367.3.667.667.667z"
        fill="#BEBFC0"
      />
    </g>
    <defs>
      <clipPath id="5ou6c0wz7a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const SidenavDropdown = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#eikx99l9ka)">
      <path
        d="m5.807 7.807 1.726 1.727c.26.26.68.26.94 0L10.2 7.807a.669.669 0 0 0-.473-1.14H6.273c-.593 0-.886.72-.466 1.14z"
        fill="#BEBFC0"
      />
    </g>
    <defs>
      <clipPath id="eikx99l9ka">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const SidenavTag = () => {
  const color = getIconColor() || primarySvgColor;
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#4fi9r0bfca)">
        <path
          d="M14.692 4.867c-.3-.425-.8-.7-1.359-.7l-9.166.008c-.917 0-1.667.742-1.667 1.659v8.333c0 .917.75 1.658 1.667 1.658l9.166.009c.559 0 1.059-.275 1.359-.7l3.3-4.65a.826.826 0 0 0 0-.967l-3.3-4.65zm-1.359 9.3H5a.836.836 0 0 1-.833-.833V6.667c0-.458.375-.833.833-.833h8.333L16.292 10l-2.959 4.167z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="4fi9r0bfca">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BroadcastTemplateDivider = (
  <svg
    width="5"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
      fill="#BEBFC0"
    />
  </svg>
);

export const InProgress = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
      fill="#E6C60D"
    />
  </svg>
);
export const FollowUp = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
      fill="#026AA7"
    />
  </svg>
);

export const phoneIconSmall = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#xoskroe23a)">
      <path
        d="M17.069 14.246a12.593 12.593 0 0 0-2.632-1.76c-.793-.379-1.078-.372-1.636.031-.465.34-.766.648-1.3.531a7.758 7.758 0 0 1-2.613-1.933 7.7 7.7 0 0 1-1.933-2.613c-.113-.54.2-.836.531-1.3.402-.559.414-.848.032-1.637a12.349 12.349 0 0 0-1.76-2.63c-.575-.575-.704-.453-1.02-.34a5.8 5.8 0 0 0-.933.496c-.483.276-.873.689-1.121 1.187-.227.48-.48 1.374.83 3.71a20.697 20.697 0 0 0 3.643 4.853 20.778 20.778 0 0 0 4.853 3.64c2.335 1.312 3.23 1.054 3.71.83.498-.246.91-.636 1.184-1.12.193-.296.359-.608.495-.933.114-.308.247-.438-.33-1.012z"
        fill="#BEBFC0"
      />
    </g>
    <defs>
      <clipPath id="xoskroe23a">
        <path
          fill="#fff"
          transform="translate(2.5 2.5)"
          d="M0 0h15v14.993H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

export const smsIconSmall = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#62ddd0kfpa)">
      <path
        d="M16 2.5H4A1.5 1.5 0 0 0 2.506 4L2.5 17.498l3-3H16a1.5 1.5 0 0 0 1.5-1.5V4A1.5 1.5 0 0 0 16 2.5zM7.749 9.249H6.25v-1.5h1.5l-.001 1.5zm3 0h-1.5v-1.5h1.5v1.5zm3 0h-1.5v-1.5h1.5v1.5z"
        fill="#BEBFC0"
      />
      <path d="M14.45 7.342H5.488v2.39h8.962v-2.39z" fill="#BEBFC0" />
      <path
        d="M13.853 6.146H6.085v.598h7.768v-.598zM13.853 7.94H6.085v.597h7.768v-.598zM13.853 9.731H6.085v.598h7.768v-.598z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="62ddd0kfpa">
        <path fill="#fff" transform="translate(2.5 2.5)" d="M0 0h15v15H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const emailIconSmall = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#116h1sopsa)">
      <path
        d="M16.667 3.333H3.333c-.916 0-1.658.75-1.658 1.667l-.008 10c0 .916.75 1.666 1.666 1.666h13.334c.916 0 1.666-.75 1.666-1.666V5c0-.917-.75-1.667-1.666-1.667zm-.334 3.542-5.891 3.683a.843.843 0 0 1-.884 0L3.667 6.875a.708.708 0 1 1 .75-1.2L10 9.166l5.583-3.491a.708.708 0 1 1 .75 1.2z"
        fill="#BEBFC0"
      />
    </g>
    <defs>
      <clipPath id="116h1sopsa">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const rcsIconSmall = (
  <svg
    width="19"
    height="19"
    viewBox="0 0 18 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.99984 11.6667H14.9998L11.8748 7.50001L9.37484 10.8333L7.49984 8.33334L4.99984 11.6667ZM1.6665 18.3333V3.33334C1.6665 2.87501 1.8297 2.48264 2.15609 2.15626C2.48248 1.82987 2.87484 1.66667 3.33317 1.66667H16.6665C17.1248 1.66667 17.5172 1.82987 17.8436 2.15626C18.17 2.48264 18.3332 2.87501 18.3332 3.33334V13.3333C18.3332 13.7917 18.17 14.184 17.8436 14.5104C17.5172 14.8368 17.1248 15 16.6665 15H4.99984L1.6665 18.3333Z"
      fill="#BEBFC0"
    />
  </svg>
);

export const spellCheckIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#wvm6jxwdya)">
      <path
        d="M9.84 12a.723.723 0 0 0 .675-.99L7.327 2.903a1.022 1.022 0 0 0-1.904 0L2.235 11.01a.726.726 0 1 0 1.357.518l.66-1.778h4.23l.676 1.785A.742.742 0 0 0 9.84 12zM4.822 8.25l1.553-4.14 1.553 4.14H4.822zm10.846.967-5.543 5.543-2.228-2.227A.747.747 0 1 0 6.84 13.59l2.76 2.76a.747.747 0 0 0 1.058 0l6.06-6.068a.747.747 0 0 0 0-1.057.745.745 0 0 0-1.05-.008z"
        fill="#777"
      />
    </g>
    <defs>
      <clipPath id="wvm6jxwdya">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const nextgenWelcomeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="190.683"
    height="195.166"
    viewBox="0 0 190.683 195.166"
  >
    <g
      id="Group_11347"
      data-name="Group 11347"
      transform="translate(-564.709 -361.956)"
    >
      <g
        id="Group_11347-2"
        data-name="Group 11347"
        transform="translate(-0.669 2.27)"
      >
        <g
          id="Group_11346"
          data-name="Group 11346"
          transform="matrix(0.985, -0.174, 0.174, 0.985, -52.996, 180.053)"
        >
          <path
            id="Path_10308"
            data-name="Path 10308"
            d="M711.591,468.127l1.363-.428a40.213,40.213,0,0,1-1.627-8.9l-1.427.109A41.5,41.5,0,0,0,711.591,468.127Zm-1.641-18.553,1.427.145c.04-.392.086-.785.138-1.175a36.99,36.99,0,0,1,.749-4c.3-1.218.668-2.443,1.094-3.644l-1.349-.476c-.44,1.246-.821,2.517-1.132,3.78a38.57,38.57,0,0,0-.787,4.148c-.05.392-.1.8-.14,1.215Zm7.333-16.84a52.89,52.89,0,0,1,5.416-7.3l-1.07-.951a54.069,54.069,0,0,0-5.559,7.507Zm44.658-3.38a7.963,7.963,0,0,0,5.043-.654,7.56,7.56,0,0,0,2.866-3.223l-1.284-.628a6.075,6.075,0,0,1-2.312,2.616,6.588,6.588,0,0,1-3.97.492.664.664,0,0,1-.145-.045l-.2-.133-.794,1.189.238.162A1.9,1.9,0,0,0,761.941,429.354Zm-32.727-10.3a73.255,73.255,0,0,1,7.312-5.452l-.783-1.189a74.783,74.783,0,0,0-7.464,5.573Zm26.778,1.891,1.4-.295a13.328,13.328,0,0,1-.281-2.669,15.845,15.845,0,0,1,.475-3.848,19.382,19.382,0,0,1,.667-2.144l-1.337-.5a20.094,20.094,0,0,0-.714,2.3,17.258,17.258,0,0,0-.521,4.2A14.645,14.645,0,0,0,755.992,420.945Zm12.566-4.4,1.289-.616a14.387,14.387,0,0,0-6.679-6.51l-.2-.093-.609,1.294.181.086A12.923,12.923,0,0,1,768.558,416.545Zm-23.707-6.408a29.532,29.532,0,0,1,5.647-1.32c1.142-.055,2.188-.067,3.194-.036l.043-1.427c-1.044-.031-2.126-.019-3.306.038a32.529,32.529,0,0,0-5.994,1.38Zm18.037-5.787a30.626,30.626,0,0,1,6.779-5.9l-.771-1.2a31.962,31.962,0,0,0-7.1,6.172Z"
            transform="translate(-65.738 -57.485)"
            fill="#c7c4e1"
          />
          <path
            id="Path_10309"
            data-name="Path 10309"
            d="M657.583,379.619a27.616,27.616,0,0,1,4.519-.852l-.145-1.427a28.975,28.975,0,0,0-4.757.894Z"
            transform="translate(54.545 -42.312)"
            fill="#c7c4e1"
          />
        </g>
        <g
          id="Group_11387"
          data-name="Group 11387"
          transform="matrix(0.985, -0.174, 0.174, 0.985, -69.968, 175.938)"
        >
          <path
            id="Path_10304"
            data-name="Path 10304"
            d="M406.952,314.735l-2.3,17.364,12.331-9,37.741-19.286-29.192,2.662s-14.871,3.613-15.677,4.341A35.815,35.815,0,0,0,406.952,314.735Z"
            transform="translate(321.996 19.729)"
            fill="#c7c4e1"
          />
          <path
            id="Path_10305"
            data-name="Path 10305"
            d="M404.65,304.252l60.694-.442-47.769,10.925Z"
            transform="translate(311.373 19.729)"
            fill="#dad7f6"
          />
          <path
            id="Path_10306"
            data-name="Path 10306"
            d="M420.553,332.2l-15.9-12.775,44.161-15.615Z"
            transform="translate(327.906 19.729)"
            fill="#dad7f6"
          />
        </g>
        <path
          id="Path_10281"
          data-name="Path 10281"
          d="M138.441,20.817c-6.167-15.692-25.164-25.1-41.255-18.875C78.82,9.05,84.909,38.263,68.227,44.17c-9.012,3.191-22.333-8.729-31.438-10.557C20.011,30.245,4.823,42.083,1.083,58.477c-3.816,16.725,2.3,39.063,20.679,43.6,21.889,5.407,33.29-14.269,51.652-19.919,18.843-5.8,39.795,7.9,55.394-8.765,11.525-12.308,15.739-37.038,9.632-52.577Z"
          transform="matrix(-0.809, -0.588, 0.588, -0.809, 679.639, 554.853)"
          fill="#f3f2f8"
        />
        <g id="Group_11388" data-name="Group 11388">
          <path
            id="Path_10303"
            data-name="Path 10303"
            d="M717.468,776.72h87.548c3.023,0,5.471,3.092,5.471,6.912v45.607c0,3.818-2.452,6.912-5.471,6.912H736.093c-2.788,4.914-7.849,13.715-8.292,13.715s.385-8.311.951-13.715H717.471c-3.026,0-5.471-3.092-5.471-6.912V783.632C711.993,779.815,714.443,776.72,717.468,776.72Z"
            transform="translate(-106.875 -340.695)"
            fill="#dad7f6"
          />
          <rect
            id="Rectangle_3048"
            data-name="Rectangle 3048"
            width="23.213"
            height="3.011"
            rx="1.506"
            transform="translate(662.768 450.813)"
            fill="#fff"
          />
          <rect
            id="Rectangle_3049"
            data-name="Rectangle 3049"
            width="15.68"
            height="3.011"
            rx="1.506"
            transform="translate(670.301 458.76)"
            fill="#fff"
          />
          <rect
            id="Rectangle_3050"
            data-name="Rectangle 3050"
            width="19.295"
            height="3.011"
            rx="1.506"
            transform="translate(648.301 458.76)"
            fill="#fff"
          />
          <rect
            id="Rectangle_3051"
            data-name="Rectangle 3051"
            width="39.335"
            height="3.011"
            rx="1.506"
            transform="translate(619.584 450.813)"
            fill="#fff"
          />
          <rect
            id="Rectangle_3052"
            data-name="Rectangle 3052"
            width="66.396"
            height="3.011"
            rx="1.506"
            transform="translate(619.584 474.332)"
            fill="#fff"
          />
          <rect
            id="Rectangle_3053"
            data-name="Rectangle 3053"
            width="34.299"
            height="3.011"
            rx="1.506"
            transform="translate(651.68 466.704)"
            fill="#fff"
          />
          <rect
            id="Rectangle_3054"
            data-name="Rectangle 3054"
            width="27.078"
            height="3.011"
            rx="1.506"
            transform="translate(619.584 466.704)"
            fill="#fff"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const QuickReplyIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.333 5.335c0-1.467-1.2-2.667-2.666-2.667H5.333A2.663 2.663 0 0 0 2.68 5.335l-.013 24L8 24h12v-9.333c0-.733.6-1.333 1.333-1.333h8v-8z"
      fill="#BEBFC0"
    />
    <path
      d="M28.92 21.333h-1.853l1.866-4.4A.67.67 0 0 0 28.32 16h-4.987a.66.66 0 0 0-.666.667v6.666a.66.66 0 0 0 .666.667h2v5.253c0 .347.48.467.627.147l3.547-7.107a.658.658 0 0 0-.587-.96z"
      fill="#BEBFC0"
    />
  </svg>
);

export const QuickAddBlue = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.667 10.834h-5.834v5.833H9.168v-5.834H3.334V9.168h5.833V3.334h1.667v5.833h5.833v1.667z"
      fill="#00B2E3"
    />
  </svg>
);

export const QuickAddGrey = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.667 10.832h-5.834v5.833H9.168v-5.833H3.334V9.165h5.833V3.332h1.667v5.833h5.833v1.667z"
      fill="#E6E6E6"
    />
  </svg>
);

export const SmallArrow = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 9.5H3a.501.501 0 0 1-.5-.5V3c0-.275.225-.5.5-.5h2.5c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-3a1 1 0 0 0-1 1v7c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-3c0-.275-.225-.5-.5-.5s-.5.225-.5.5V9c0 .275-.225.5-.5.5zM7 2c0 .275.225.5.5.5h1.295L4.23 7.065a.498.498 0 1 0 .705.705L9.5 3.205V4.5c0 .275.225.5.5.5s.5-.225.5-.5V2c0-.275-.225-.5-.5-.5H7.5c-.275 0-.5.225-.5.5z"
      fill="#BEBFC0"
    />
  </svg>
);

export const VoiceIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M4.56705 11.3692V4.62681C4.56705 4.42098 4.63758 4.24845 4.77864 4.10921C4.9197 3.96998 5.09265 3.90036 5.29748 3.90036C5.50232 3.90036 5.6746 3.96998 5.81434 4.10921C5.95407 4.24845 6.02393 4.42098 6.02393 4.62681V11.3732C6.02393 11.579 5.95432 11.7515 5.81508 11.8908C5.67584 12.03 5.50331 12.0996 5.29748 12.0996C5.09265 12.0996 4.9197 12.0291 4.77864 11.888C4.63758 11.747 4.56705 11.574 4.56705 11.3692ZM7.27357 14.0757V1.92426C7.27357 1.71844 7.34318 1.54591 7.48242 1.40668C7.62166 1.26744 7.7942 1.19781 8.00002 1.19781C8.20584 1.19781 8.37837 1.26744 8.51762 1.40668C8.65685 1.54591 8.72647 1.71844 8.72647 1.92426V14.0757C8.72647 14.2816 8.65685 14.4541 8.51762 14.5933C8.37837 14.7326 8.20584 14.8022 8.00002 14.8022C7.7942 14.8022 7.62166 14.7326 7.48242 14.5933C7.34318 14.4541 7.27357 14.2816 7.27357 14.0757ZM1.8645 8.66268V7.33333C1.8645 7.12751 1.93504 6.95498 2.0761 6.81573C2.21717 6.6765 2.39012 6.60688 2.59495 6.60688C2.79977 6.60688 2.97205 6.67741 3.11179 6.81848C3.25153 6.95954 3.3214 7.13248 3.3214 7.33732V8.66667C3.3214 8.87249 3.25178 9.04502 3.11254 9.18426C2.9733 9.3235 2.80077 9.39312 2.59495 9.39312C2.39012 9.39312 2.21717 9.32258 2.0761 9.18151C1.93504 9.04046 1.8645 8.86751 1.8645 8.66268ZM9.97212 11.3692V4.62681C9.97212 4.42098 10.0427 4.24845 10.1837 4.10921C10.3248 3.96998 10.4977 3.90036 10.7026 3.90036C10.9074 3.90036 11.0797 3.96998 11.2194 4.10921C11.3591 4.24845 11.429 4.42098 11.429 4.62681V11.3732C11.429 11.579 11.3594 11.7515 11.2202 11.8908C11.0809 12.03 10.9084 12.0996 10.7026 12.0996C10.4977 12.0996 10.3248 12.0291 10.1837 11.888C10.0427 11.747 9.97212 11.574 9.97212 11.3692ZM12.6786 8.66268V7.33333C12.6786 7.12751 12.7492 6.95498 12.8902 6.81573C13.0313 6.6765 13.2043 6.60688 13.4091 6.60688C13.6139 6.60688 13.7862 6.67741 13.9259 6.81848C14.0657 6.95954 14.1355 7.13248 14.1355 7.33732V8.66667C14.1355 8.87249 14.0659 9.04502 13.9267 9.18426C13.7874 9.3235 13.6149 9.39312 13.4091 9.39312C13.2043 9.39312 13.0313 9.32258 12.8902 9.18151C12.7492 9.04046 12.6786 8.86751 12.6786 8.66268Z"
      fill="#BEBFC0"
    />
  </svg>
);

export const DownArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      width="18"
      viewBox="0 -960 960 960"
      fill="#00b2e3"
    >
      <path d="M444-768v438L243-531l-51 51 288 288 288-288-51-51-201 201v-438h-72Z" />
    </svg>
  );
};

export const SettingsIcon = () => {
  const color = getIconColor() || primarySvgColor;
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Material/settings_24px">
        <path
          id="Vector"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.4824 15.7725C11.4074 16.2825 10.9424 16.6875 10.3874 16.6875H7.61243C7.05743 16.6875 6.59243 16.2825 6.52493 15.735L6.32243 14.3175C6.11993 14.2125 5.92493 14.1 5.72993 13.9725L4.37993 14.5125C3.85493 14.7075 3.27743 14.49 3.02243 14.025L1.64993 11.6475C1.38743 11.1525 1.49993 10.5675 1.91993 10.2375L3.06743 9.34501C3.05993 9.23251 3.05243 9.12001 3.05243 9.00001C3.05243 8.88751 3.05993 8.76751 3.06743 8.65501L1.92743 7.76251C1.48493 7.42501 1.37243 6.81751 1.64993 6.35251L3.03743 3.96001C3.29243 3.49501 3.86993 3.28501 4.37993 3.48751L5.73743 4.03501C5.93243 3.90751 6.12743 3.79501 6.32243 3.69001L6.52493 2.25751C6.59243 1.73251 7.05743 1.32001 7.60493 1.32001H10.3799C10.9349 1.32001 11.3999 1.72501 11.4674 2.27251L11.6699 3.69001C11.8724 3.79501 12.0674 3.90751 12.2624 4.03501L13.6124 3.49501C14.1449 3.30001 14.7224 3.51751 14.9774 3.98251L16.3574 6.36751C16.6274 6.86251 16.5074 7.44751 16.0874 7.77751L14.9474 8.67001C14.9549 8.78251 14.9624 8.89501 14.9624 9.01501C14.9624 9.13501 14.9549 9.24751 14.9474 9.36001L16.0874 10.2525C16.5074 10.59 16.6274 11.175 16.3649 11.6475L14.9699 14.0625C14.7149 14.5275 14.1374 14.7375 13.6199 14.535L12.2699 13.995C12.0749 14.1225 11.8799 14.235 11.6849 14.34L11.4824 15.7725ZM7.96493 15.1875H10.0349L10.3124 13.275L10.7099 13.11C11.0399 12.975 11.3699 12.78 11.7149 12.525L12.0524 12.27L13.8374 12.99L14.8724 11.19L13.3499 10.005L13.4024 9.58501L13.4048 9.56482C13.4265 9.37704 13.4474 9.1955 13.4474 9.00001C13.4474 8.79751 13.4249 8.60251 13.4024 8.41501L13.3499 7.99501L14.8724 6.81001L13.8299 5.01001L12.0374 5.73001L11.6999 5.46751C11.3849 5.22751 11.0474 5.03251 10.7024 4.89001L10.3124 4.72501L10.0349 2.81251H7.96493L7.68743 4.72501L7.28993 4.88251C6.95993 5.02501 6.62993 5.21251 6.28493 5.47501L5.94743 5.72251L4.16243 5.01001L3.11993 6.80251L4.64243 7.98751L4.58993 8.40751C4.56743 8.60251 4.54493 8.80501 4.54493 9.00001C4.54493 9.19501 4.55993 9.39751 4.58993 9.58501L4.64243 10.005L3.11993 11.19L4.15493 12.99L5.94743 12.27L6.28493 12.5325C6.60743 12.78 6.92993 12.9675 7.28243 13.11L7.67993 13.275L7.96493 15.1875ZM11.6249 9.00001C11.6249 10.4498 10.4497 11.625 8.99993 11.625C7.55018 11.625 6.37493 10.4498 6.37493 9.00001C6.37493 7.55026 7.55018 6.37501 8.99993 6.37501C10.4497 6.37501 11.6249 7.55026 11.6249 9.00001Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const QuestionMarkIcon = () => (
  <svg width="14.75" height="13.75" viewBox="0 0 13.75 13.75">
    <path
      style={{ fill: "#bebfc0" }}
      d="M14.313 7.438A6.875 6.875 0 1 1 7.438.563a6.875 6.875 0 0 1 6.875 6.875zm-6.691-4.6A3.591 3.591 0 0 0 4.391 4.6a.333.333 0 0 0 .075.451l.962.729a.333.333 0 0 0 .462-.059c.5-.628.835-.992 1.589-.992.566 0 1.267.364 1.267.914 0 .415-.343.628-.9.942-.652.366-1.515.821-1.515 1.959v.111a.333.333 0 0 0 .333.333h1.55a.333.333 0 0 0 .333-.333V8.62c0-.789 2.306-.822 2.306-2.957a3.163 3.163 0 0 0-3.231-2.827zm-.184 6.873a1.275 1.275 0 1 0 1.275 1.275 1.277 1.277 0 0 0-1.275-1.275z"
      transform="translate(-.563 -.563)"
    />
  </svg>
);

export const WarningFilledIcon = ({ fill = "#E2C500", withCircle = false }) => {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.72494 14.5001H14.2749C15.5583 14.5001 16.3583 13.1084 15.7166 12.0001L9.4416 1.1584C8.79994 0.0500651 7.19994 0.0500651 6.55827 1.1584L0.283272 12.0001C-0.358395 13.1084 0.441605 14.5001 1.72494 14.5001ZM7.99994 8.66673C7.5416 8.66673 7.1666 8.29173 7.1666 7.8334V6.16673C7.1666 5.7084 7.5416 5.3334 7.99994 5.3334C8.45827 5.3334 8.83327 5.7084 8.83327 6.16673V7.8334C8.83327 8.29173 8.45827 8.66673 7.99994 8.66673ZM8.83327 12.0001H7.1666V10.3334H8.83327V12.0001Z"
        fill={fill}
      />
      {withCircle && <circle cx="12" cy="3" r="3" fill="#a30e0e" />}
    </svg>
  );
};

export const InfoOutlineIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_143_3214)">
        <path
          d="M9.16667 5.83333H10.8333V7.5H9.16667V5.83333ZM10 14.1667C10.4583 14.1667 10.8333 13.7917 10.8333 13.3333V10C10.8333 9.54167 10.4583 9.16667 10 9.16667C9.54167 9.16667 9.16667 9.54167 9.16667 10V13.3333C9.16667 13.7917 9.54167 14.1667 10 14.1667ZM10 1.66667C5.4 1.66667 1.66667 5.4 1.66667 10C1.66667 14.6 5.4 18.3333 10 18.3333C14.6 18.3333 18.3333 14.6 18.3333 10C18.3333 5.4 14.6 1.66667 10 1.66667ZM10 16.6667C6.325 16.6667 3.33333 13.675 3.33333 10C3.33333 6.325 6.325 3.33333 10 3.33333C13.675 3.33333 16.6667 6.325 16.6667 10C16.6667 13.675 13.675 16.6667 10 16.6667Z"
          fill="#BEBFC0"
        />
      </g>
      <defs>
        <clipPath id="clip0_143_3214">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
